import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { SearchSelectBox } from 'jbc-front/components/SearchForm';
import { arrowRenderer } from 'jbc-front/components/Form';

import { getSelectOptions } from 'src/reducers/selectOptions';
import styles from './SelectBoxYear.scss';

class SelectBoxYear extends React.Component {
  render() {
    const { wageLedgerYears } = this.props;
    return (
      <div className={styles.container}>
        <Field name="year" component={SearchSelectBox} options={wageLedgerYears} arrowRenderer={arrowRenderer} />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  wageLedgerYears: getSelectOptions(state, 'wageLedgerYears')
});
export default connect(mapStateToProps)(SelectBoxYear);
